import { LOGOUT_TYPE } from '../appConstants';

const { SIGNOUT_DESTINATION_URL, CIAM_API_HOST } = window.__ENV__;

export const getLogoutURL = (logoutType, locale, isCiamSession) => {
  if (isCiamSession) {
    let signoutReason;

    switch (logoutType) {
      case LOGOUT_TYPE.idle:
        signoutReason = 'inactive';
        break;
      case LOGOUT_TYPE.maxSession:
        signoutReason = 'session';
        break;
      default:
        signoutReason = 'sign-out';
        break;
    }
    const params = { sign_out: signoutReason, ui_locales: locale };
    const queryParams = new URLSearchParams(params);

    return `${CIAM_API_HOST}/?${queryParams}`;
  }
  return SIGNOUT_DESTINATION_URL;
};
